export const FinishSetUpNC = {
	methods: {
		postFinishSetUpNC(response) {
			if (response.status == 201) {
				this.$store.commit(
					"StoreEmail",
					this.$store.state.userRegistration.email
				);
				this.$router.push({
					path: `/user-registration/resend-activation/`
				}).catch(()=>{});
				this.$notify.success({
					title: "Success",
					message: JSON.parse(response.data).message
				});
			}
		}
	}
};
